<script>
    import { isEmptyObject } from "../../utils";
    export let bordered = false;
    export let content = "";
    export let color = "";
    let cls = "sui-badge";
</script>

<div class={`${cls}-wrapper`}>
    <slot />
    <b
        class={`${cls} ${$$props.class || ""}`}
        style:--color={color}
        class:dot={content === ""}
        class:fixed={!isEmptyObject($$slots)}
        class:bordered>{content}</b
    >
</div>

<style lang="less">
    @import "./badge.less";
</style>
